import L from 'leaflet';
import 'leaflet.markercluster';

export default L;
